module.exports = __webpack_public_path__ + "img/CAA78A_F9E7D7_EAD0B9_F3DCC3-256px.8f5a1261.png";